<template>
  <div>
    <v-autocomplete
      v-model="address"
      @change="setAddress"
      :items="appointmentAddresses"
      :label="$t('appointment.formCreate.labels.keyLocation')"
      :no-data-text="$t('appointment.formCreate.labels.noLocationFound')"
      :rules="rules"
      ref="keyAddress"
      item-value="id"
      return-object
      single-line
      outlined
    >
      <template v-slot:item="data">
        <span class="body-2 grey--text text--darken-1">
          {{ data.item.address }}
        </span>
      </template>
      <template v-slot:selection="data">
        <div class="d-flex align-center">
          <v-chip
            :color="handleColors(data.item.location)"
            class="ml-0 mr-3 mw-50 text-center justify-center"
            small
            dark
          >
            {{ $t(`appointment.keyLocation.${data.item.location}`) }}
          </v-chip>
          <span class="d-block mw-450 body-2 text-truncate">
            {{ data.item.address }}
          </span>
        </div>
      </template>
      <template slot="append-item">
        <div class="mb-n2">
          <v-divider />
          <v-btn
            @click="openModal('SELECT_CUSTOM_ADDRESS')"
            class="d-block py-5 mh-60"
            color="primary"
            block
            large
            text
          >
            <v-icon color="primary lighten-1" left>
              mdi-map-marker-plus-outline
            </v-icon>
            <div class="d-block pl-2">
              <span class="d-block body-2 mb-0 font-weight-bold">
                {{ $t('appointment.formCreate.labels.addAddress') }}
              </span>
            </div>
          </v-btn>
        </div>
      </template>
    </v-autocomplete>

    <ModalCustomKeyAddress @click="applyCustomAddress" />
  </div>
</template>

<script>
import { handleColors } from '@/util/colors'
import { mapGetters, mapMutations, mapActions } from 'vuex'

import ModalCustomKeyAddress from '../../modals/ModalCustomKeyAddress'

export default {
  name: 'KeySelect',

  components: { ModalCustomKeyAddress },

  props: {
    rules: {
      type: [Array, Object],
    },
  },

  data() {
    return {
      address: null,
      otherFields: false,
      showNumberField: true,
      showNewAddressButton: true,
      handleColors,
    }
  },

  watch: {
    appointmentFields({ key_location_options }) {
      if (!key_location_options) return

      const { id } = key_location_options
      if (id === null) this.address = 'googleAddress'
      else this.address = id
    },
  },

  computed: {
    ...mapGetters(['isLoading', 'appointmentFields', 'appointmentAddresses']),
  },

  methods: {
    ...mapActions(['openModal', 'fetchBranches', 'showErrorMessage']),
    ...mapMutations(['setAppointmentFields']),

    setAddress(payload) {
      if (!payload && !payload?.id) return

      const { id, address, location } = payload
      const { key_location_options } = this.appointmentFields

      if (id !== 'googleAddress') {
        this.setAppointmentFields({
          key_location_options: {
            ...key_location_options,
            id,
            key_location: location,
            address: null,
          },
        })
      } else {
        this.setAppointmentFields({
          key_location_options: {
            ...key_location_options,
            id: 'googleAddress',
            key_location: location,
            address,
          },
        })
      }

      this.setAppointmentFields({
        key_location_address: address,
      })
    },

    applyCustomAddress(googleAddress) {
      const { id } = googleAddress[0]
      this.address = id
      this.showNewAddressButton = false
    },
  },
}
</script>
